import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import {
  Button,
  ButtonBase,
  Hidden,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import FilterListIcon from '@material-ui/icons/FilterList'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Lightbox from 'yet-another-react-lightbox'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import 'yet-another-react-lightbox/plugins/thumbnails.css'
import 'yet-another-react-lightbox/styles.css'

import coverPhoto from '../../assets/images/noCoverForHotel.png'
import noResultsFound from '../../assets/images/noResultFound.svg'
import { CartDetails, totalQuantityVar } from '../../cache/cart'
import { cartDetailsVar } from '../../cache/cart'
import AdotelSkeleton from '../../components/AdotelSkeleton'
import { RedirectModal } from '../../components/RedirectModal'
import {
  CREATE_CART_MUTATION,
  DELETE_CART_MUTATION,
  GET_CART_QUERY,
  RESET_CART_MUTATION
} from '../../graphql/cartCrud'
import { SEARCH_AVAILABILITY_QUERY } from '../../graphql/searchAvailability'
import { WALLETS_QUERY } from '../../graphql/wallet'
import { CREDITORS_QUERY } from '../../graphql/walletCreditors'
import { getCartProviderIdentity } from '../../helpers/cartProviderIdentity'
import { errorNoCartFound, extractError } from '../../helpers/regex'
import { cleanCartData } from '../../helpers/userData'
import { getTranslate, lang } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import {
  ItemsInCart,
  CartResponse,
  CreateCart,
  ItemInput
} from '../../types/cart'
import { Currency } from '../../types/currency'
import { CheckBoxDataType } from '../../types/customCheckBox'
import {
  Entities,
  RoomForSearch,
  SearchAvailabilityInput,
  SearchAvailabilityResponse
} from '../../types/searchAvailability'
import { SelectedWalletType, WalletListItem } from '../../types/wallet'
import { CreditorListItem } from '../../types/walletCreditor'
import SearchWidgetMain from '../Booking/SearchWidgets/SearchWidgetMain'
import AccommodationNameAndAddress from './components/AccommodationNameAndAddress'
import FilterDrawer from './components/FilterDrawer'
import PaymentWallet from './components/PaymentWallet'
import PropertyDescription from './components/PropertyDescription'
import RoomTypeDetails from './components/RoomTypeDetails'
import SearchAvailibilityFilters from './components/SearchAvailibilityFilters'
import { Gallery } from './components/gallery'
import {
  transformRatePlansWithWallets,
  transformRoomsWithCart
} from './helpers'
import useStyles from './styles/index.styles'

const BookingHotelSearchResult = () => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [filterOpen, setFilterOpen] = useState(false)
  const hasMountedForPrice = useRef(false)
  const hasMountedForOtherFilters = useRef(false)
  const scrollRef = useRef(0)
  const searchRequestIdRef = useRef(0)
  const history = useHistory()
  const params = useParams<{ channelId: string; code: string; name: string }>()
  const [dataLoaded, setDataLoaded] = useState(false)
  const filterParams = new URLSearchParams(location.search)
  const filterFields = filterParams.get('filter')
  const decodedFilterFields = filterFields && decodeURIComponent(filterFields)
  const newFilterFields: SearchAvailabilityInput =
    decodedFilterFields && JSON.parse(decodedFilterFields)

  const [searchAvailabilityInput, setSearchAvailabilityInput] =
    useState<SearchAvailabilityInput>(newFilterFields)

  const [maxPriceRange, setmaxPriceRange] = useState<number>(0)
  const [priceRange, setPriceRange] = React.useState<number[]>([
    0,
    maxPriceRange
  ])
  const [searchData, setSearchData] = useState<Entities | undefined>(undefined)

  const [readMode, setreadMode] = useState(true)
  const [openGallary, setOpenGallary] = useState(false)
  const [showRedirectModal, setShowRedirectModal] = useState(false)
  const [redirectTitle, setRedirectTitle] = useState('')
  const [filteredRoomType, setFilteredRoomType] = useState<RoomForSearch[]>([])
  const [selectedRoomTypes, setselectedRoomTypes] = useState<string[]>([])
  const [selectedProviders, setSelectedProviders] = useState<string[]>([])
  const [selectedRoomFacilities, setSelectedRoomFacilities] = useState<
    string[]
  >([])
  const [validProviderCode, setValidProviderCode] = useState('')
  const [slides, setslides] = useState<
    {
      src: string
    }[]
  >([])
  const [walletTypes, setWalletTypes] = useState<
    {
      name: string
      id: string
      currency: Currency
      cashBalance: number
      remainingCreditBalance: number
    }[]
  >([])
  const [nonBillateralWallet, setNonBillateralWallet] = useState<{
    walletName: string
    walletID: string
    creditorID?: undefined
    cashBalance: number | 0
    remainigCreditBalance: number | 0
  }>()
  const [allCreditors, setAllCreditors] = useState<
    {
      walletName: string
      walletID: string
      creditorItems: CreditorListItem[]
    }[]
  >([])

  const [selectedWalletType, setSelectedWalletType] =
    useState<SelectedWalletType>({ walletName: '', walletID: '' })
  const selectedWalletTypeRef = useRef(selectedWalletType)
  selectedWalletTypeRef.current = selectedWalletType

  const [itemsInCart, setItemsInCart] = useState<ItemsInCart>({
    cartID: '',
    items: []
  })

  const [selectedItemHash, setSelectedItemHash] = useState('')
  const [initialData, setInitialData] = useState<{
    uniqueRoomFacilities: CheckBoxDataType[]
    uniqueProviders: CheckBoxDataType[]
    roomTypeNames: { label: string; value: string }[]
  } | null>(null)

  //CREDITOR_LIST_QUERY
  const [getCreditors] = useLazyQuery<{
    creditors: CreditorListItem[]
  }>(CREDITORS_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    onCompleted: (res) => {
      setAllCreditors((prev) =>
        Array.isArray(prev)
          ? prev.map((ele) => ({
              ...ele,
              creditorItems: res.creditors.filter(
                (cr) => cr.active && cr.entity.entityType == 'Provider'
              )
            }))
          : []
      )
    }
  })

  //CREATE_CART_MUTATION
  const [createCart] = useMutation<{ createCart: CreateCart }>(
    CREATE_CART_MUTATION,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: (res) => {
        const newCartDetails = {
          channelID: params.channelId,
          channelCode: params.code,
          channelName: params.name,
          propertyCode: searchAvailabilityInput?.propertyCode || '',
          currrncy: searchAvailabilityInput.currency
        }
        setItemsInCart({ ...itemsInCart, cartID: res.createCart.cartID })
        cartDetailsVar(newCartDetails)
        localStorage.setItem('cartDetails', JSON.stringify(newCartDetails))
        localStorage.setItem('cartID', res.createCart.cartID)
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        getCart({
          variables: {
            cartID: res.createCart.cartID
          }
        })
      },
      onError: (err) => {
        setShowRedirectModal(true)
        setRedirectTitle('Creating cart failed. try again')
        toast.error(err.message)
      }
    }
  )

  //WALLET_LIST_QUERY
  useQuery<{
    wallets: WalletListItem[]
  }>(WALLETS_QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {
      filters: {
        entity: {
          entityType: 'Channel',
          entityID: params.channelId
        },
        currency: searchAvailabilityInput.currency,
        sortBy: 'default'
      }
    },
    onCompleted: (resp) => {
      const temp: {
        name: string
        id: string
        currency: Currency
        cashBalance: number
        remainingCreditBalance: number
      }[] = resp.wallets.map((w) => {
        if (!w.isBilateral) {
          setNonBillateralWallet({
            walletName: w.walletType,
            walletID: w.walletID,
            cashBalance: w.walletBalance,
            remainigCreditBalance: w.remainingCreditBalance
          })
        }
        return {
          name: w.walletType,
          id: w.walletID,
          currency: w.currency,
          cashBalance: w.walletBalance,
          remainingCreditBalance: w.remainingCreditBalance
        }
      })

      if (temp.length === 1) {
        setSelectedWalletType({
          walletID: temp[0].id,
          walletName: temp[0].name
        })
      }
      setWalletTypes(temp)

      const wallets = resp.wallets.filter((w) => w.isBilateral)

      wallets.map((w) => {
        getCreditors({
          variables: {
            filters: { walletID: w.walletID, sortBy: 'default' }
          }
        })

        setAllCreditors((prev) => [
          ...prev,
          {
            walletName: w.walletType,
            walletID: w.walletID,
            creditorItems: []
          }
        ])
      })
    }
  })

  //GET_CART_QUERY
  const [getCart, { data: cartData, loading: loadingForGetCart }] =
    useLazyQuery<{
      cartResponse: CartResponse
    }>(GET_CART_QUERY, {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      onCompleted: (res) => {
        const elemens = res.cartResponse.cart.items || []
        const totalQuantity = elemens.reduce(
          (sum, item) => sum + (item.quantity || 0),
          0
        )
        totalQuantityVar(totalQuantity)
        localStorage.setItem('totalQuantity', totalQuantity.toString())
        if (res.cartResponse.cart.items.length > 0) {
          setValidProviderCode(
            getCartProviderIdentity(res.cartResponse.cart.items[0]).displayCode
          )
        }
        const items: ItemInput[] = res.cartResponse.cart.items
          .filter((ele) => ele.quantity > 0)
          .map((item) => {
            return {
              adults: item.occupancy.adults,
              arrival: item.arrival,
              departure: item.departure,
              extraBeds: item.occupancy.extraBeds,
              providerCode: getCartProviderIdentity(item).inputCode,
              ratePlanCode: item.ratePlan.ratePlanCode,
              roomTypeCode: item.roomType.roomTypeCode,
              useAllocated: item.useAllocated,
              quantity: item.quantity,
              price: item.price.afterDiscount.totalPrice
            }
          })

        setItemsInCart({
          cartID: localStorage.getItem('cartID') || '',
          items: items
        })

        setSelectedWalletType((prev) => {
          if (prev.walletName) {
            return prev
          } else {
            return {
              walletID: res.cartResponse.cart.paymentInfo.walletID,
              walletName: res.cartResponse.cart.paymentInfo.walletType
            }
          }
        })
        const updatedRooms: RoomForSearch[] = searchData!.rooms.map((room) => ({
          ...room,
          ratePlans: room.ratePlans.map((rp) => {
            const matchingItem = elemens.find((item) => item.hash === rp.hash)

            return {
              ...rp,
              count: matchingItem?.quantity || 0
            }
          })
        }))

        // Update your data state with the modified entity
        setSearchData({
          ...searchData!,
          rooms: updatedRooms
        })
      },
      onError: (err) => {
        // graphQLErrors is empty on a network failure and absent when the value reaching
        // here is not an ApolloError, so indexing [0] crashes the error handler itself.
        const firstGraphQLError = err?.graphQLErrors?.[0]
        if (
          firstGraphQLError &&
          extractError(firstGraphQLError.extensions) === errorNoCartFound
        ) {
          cleanCartData()
          localStorage.removeItem('confirmPrimitiveInput')
          localStorage.removeItem('confirmPrimitiveOutput')
          localStorage.removeItem('hotelDetails')
          localStorage.removeItem('primitiveData')
          if (
            searchAvailabilityInput.propertyCode &&
            searchAvailabilityInput.currency
          ) {
            createCart({
              variables: {
                input: {
                  channelCode: params.code,
                  currency: searchAvailabilityInput.currency,
                  propertyCode: searchAvailabilityInput.propertyCode
                }
              }
            })
          }
        } else {
          toast.error(getTranslate('Something went wrong'))
        }
      }
    })
  const cartDataRef = useRef(cartData)
  cartDataRef.current = cartData
  const isUserPriceChange = useRef(false)

  //SEARCH_AVAILIBILITY_QUERY
  const [getSearchData, { loading: loadingForSearchAvailability }] =
    useLazyQuery<{ searchAvailability: SearchAvailabilityResponse }>(
      SEARCH_AVAILABILITY_QUERY,
      {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only'
      }
    )

  const applySearchResponse = useCallback(
    (response: SearchAvailabilityResponse) => {
      const entity = response.entities[0]

      if (!entity) {
        setSearchData(undefined)
        return
      }

      setmaxPriceRange(entity.entityBasicDetails.maxPrice)
      const cartItems = cartDataRef.current?.cartResponse.cart.items || []
      const roomsWithCart = transformRoomsWithCart(entity.rooms, cartItems)
      const roomsWithWallets = transformRatePlansWithWallets(
        roomsWithCart,
        selectedWalletTypeRef.current
      )

      setSearchData({ ...entity, rooms: roomsWithWallets })
      setslides(
        entity.entityBasicDetails.images?.map((img) => ({ src: img })) || []
      )
    },
    []
  )

  const runLatestSearch = useCallback(
    async (input: SearchAvailabilityInput) => {
      const requestId = ++searchRequestIdRef.current

      try {
        const result = await getSearchData({ variables: { input } })
        if (requestId !== searchRequestIdRef.current) return false

        if (!result.data?.searchAvailability) {
          setSearchData(undefined)
          return true
        }

        applySearchResponse(result.data.searchAvailability)
        return true
      } catch {
        if (requestId !== searchRequestIdRef.current) return false
        setSearchData(undefined)
        return true
      }
    },
    [applySearchResponse, getSearchData]
  )

  useEffect(
    () => () => {
      searchRequestIdRef.current += 1
    },
    []
  )

  //DELETE_CART_MUTATION
  const [deleteCart] = useMutation(DELETE_CART_MUTATION, {
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      cleanCartData()
      localStorage.removeItem('confirmPrimitiveInput')
      localStorage.removeItem('confirmPrimitiveOutput')
      localStorage.removeItem('hotelDetails')
      localStorage.removeItem('primitiveData')
      if (
        searchAvailabilityInput.propertyCode &&
        searchAvailabilityInput.currency
      ) {
        createCart({
          variables: {
            input: {
              channelCode: params.code,
              currency: searchAvailabilityInput.currency,
              propertyCode: searchAvailabilityInput.propertyCode
            }
          }
        })
      }
    },
    onError: () => {
      cleanCartData()
      localStorage.removeItem('confirmPrimitiveInput')
      localStorage.removeItem('confirmPrimitiveOutput')
      localStorage.removeItem('hotelDetails')
      localStorage.removeItem('primitiveData')
      if (
        searchAvailabilityInput.propertyCode &&
        searchAvailabilityInput.currency
      ) {
        createCart({
          variables: {
            input: {
              channelCode: params.code,
              currency: searchAvailabilityInput.currency,
              propertyCode: searchAvailabilityInput.propertyCode
            }
          }
        })
      }
    }
  })

  //RESET_CART
  const [resetCart] = useMutation(RESET_CART_MUTATION, {
    notifyOnNetworkStatusChange: true,
    onCompleted: (res) => {
      totalQuantityVar(0)
      localStorage.removeItem('totalQuantity')
      toast.success(res.message)
      setValidProviderCode('')
      getCart({
        variables: {
          cartID: localStorage.getItem('cartID')
        }
      })
    }
  })

  useEffect(() => {
    let cancelled = false
    let frameId: number | null = null

    if (readMode) {
      scrollRef.current = window.scrollY
      setDataLoaded(false)

      runLatestSearch({
        ...searchAvailabilityInput,
        hotelPrice: undefined,
        roomTypeFacilities: selectedRoomFacilities,
        providerCodes: selectedProviders
      }).then((applied) => {
        if (cancelled || !applied) return

        frameId = requestAnimationFrame(() => {
          if (!cancelled) {
            setDataLoaded(true)
          }
        })
      })

      if (!localStorage.getItem('cartID')) {
        createCart({
          variables: {
            input: {
              channelCode: params.code,
              currency: searchAvailabilityInput.currency,
              propertyCode: searchAvailabilityInput.propertyCode
            }
          }
        })
      } else {
        const CartDetailsJson = localStorage.getItem('cartDetails')
        const cartDetails: CartDetails = CartDetailsJson
          ? JSON.parse(CartDetailsJson)
          : {
              channelID: '',
              channelCode: '',
              channelName: '',
              propertyCode: '',
              currrncy: ''
            }

        if (
          cartDetails.channelID === searchAvailabilityInput.channelId &&
          cartDetails.propertyCode === searchAvailabilityInput.propertyCode &&
          cartDetails.currrncy === searchAvailabilityInput.currency &&
          localStorage.getItem('cartID')
        ) {
          getCart({ variables: { cartID: localStorage.getItem('cartID') } })
        } else {
          if (localStorage.getItem('cartID')) {
            deleteCart({
              variables: { cartID: localStorage.getItem('cartID') }
            })
          }
        }
      }
    }
    return () => {
      cancelled = true
      if (frameId !== null) {
        cancelAnimationFrame(frameId)
      }
    }
  }, [readMode])

  useEffect(() => {
    let cancelled = false
    let frameId: number | null = null

    if (!hasMountedForOtherFilters.current) {
      hasMountedForOtherFilters.current = true
      return
    }
    scrollRef.current = window.scrollY
    setDataLoaded(false)

    runLatestSearch({
      ...searchAvailabilityInput,
      hotelPrice:
        maxPriceRange !== 0
          ? {
              min: priceRange[0],
              max: priceRange[1]
            }
          : undefined,
      roomTypeFacilities: selectedRoomFacilities,
      providerCodes: selectedProviders
    }).then((applied) => {
      if (cancelled || !applied) return

      frameId = requestAnimationFrame(() => {
        if (!cancelled) {
          setDataLoaded(true)
        }
      })
    })

    return () => {
      cancelled = true
      if (frameId !== null) {
        cancelAnimationFrame(frameId)
      }
    }
  }, [
    selectedRoomFacilities,
    selectedProviders,
    searchAvailabilityInput.showUnavailableRatePlans
  ])

  useEffect(() => {
    if (!dataLoaded) return
    window.scrollTo({ top: scrollRef.current, behavior: 'auto' })
  }, [dataLoaded])

  useEffect(() => {
    let cancelled = false
    let frameId: number | null = null

    if (!hasMountedForPrice.current) {
      hasMountedForPrice.current = true
      return
    }

    if (!isUserPriceChange.current) return

    scrollRef.current = window.scrollY
    setDataLoaded(false)

    const handler = setTimeout(() => {
      runLatestSearch({
        ...searchAvailabilityInput,
        hotelPrice:
          maxPriceRange !== 0
            ? {
                min: priceRange[0],
                max: priceRange[1]
              }
            : undefined,
        roomTypeFacilities: selectedRoomFacilities,
        providerCodes: selectedProviders
      }).then((applied) => {
        if (cancelled || !applied) return

        frameId = requestAnimationFrame(() => {
          if (!cancelled) {
            window.scrollTo({ top: scrollY, behavior: 'auto' })
          }
        })
      })
    }, 1500)

    return () => {
      cancelled = true
      clearTimeout(handler)
      if (frameId !== null) {
        cancelAnimationFrame(frameId)
      }
    }
  }, [priceRange[0], priceRange[1]])

  useEffect(() => {
    if (searchData) {
      setSearchData({
        ...searchData,
        rooms: transformRatePlansWithWallets(
          searchData.rooms,
          selectedWalletType
        )
      })
    }

    if (
      cartData &&
      cartData.cartResponse.cart.items.length > 0 &&
      cartData.cartResponse.cart.paymentInfo.walletType !==
        selectedWalletType.walletName
    ) {
      resetCart({ variables: { cartID: localStorage.getItem('cartID') } })
    }
  }, [selectedWalletType.walletID])

  useEffect(() => {
    if (
      validProviderCode &&
      cartData &&
      cartData?.cartResponse.cart.items[0] &&
      getCartProviderIdentity(cartData.cartResponse.cart.items[0])
        .displayCode !== validProviderCode
    ) {
      resetCart({ variables: { cartID: localStorage.getItem('cartID') } })
    }
  }, [validProviderCode])

  const buttonDisabled =
    showRedirectModal ||
    (cartData
      ? cartData?.cartResponse.cart.items &&
        cartData?.cartResponse.cart.items.length < 1
        ? true
        : cartData?.cartResponse.cart.items.every((ele) => ele.quantity === 0)
      : true)

  return (
    <>
      <div className={classes.stickyDiv}>
        <div className={classes.searchContainer}>
          <SearchWidgetMain
            setSearchAvailabilityInput={setSearchAvailabilityInput}
            searchAvailabilityInput={searchAvailabilityInput}
            readMode={readMode}
            setreadMode={setreadMode}
            isInResultPage
          />
        </div>
      </div>
      <div className={classes.root}>
        <div className={classes.backButtonContainer}>
          <Button
            variant="text"
            className={classes.backBtn}
            startIcon={
              <NavigateBeforeIcon
                style={{
                  transform: lang === 'fa' ? 'rotate(180deg)' : 'none',
                  fontSize: 24,
                  marginLeft: -12
                }}
              />
            }
            onClick={() => history.goBack()}>
            <Typography variant="h4" className={classes.filterText}>
              {getTranslate('Back ')}
            </Typography>
          </Button>
        </div>
        {searchData && searchData?.rooms?.length > 0 ? (
          <>
            <Gallery
              images={
                !!searchData.entityBasicDetails.coverImage
                  ? [
                      searchData.entityBasicDetails.coverImage,
                      ...searchData.entityBasicDetails.images
                    ]
                  : searchData.entityBasicDetails.images.length > 0
                  ? searchData.entityBasicDetails.images
                  : [coverPhoto]
              }
              isCover={
                !!searchData.entityBasicDetails.coverImage ||
                searchData.entityBasicDetails.images.length === 0
              }
            />
            <AccommodationNameAndAddress searchData={searchData} />
            <PropertyDescription searchData={searchData} />
            <div className={classes.row}>
              <Typography className={classes.primaryTitle}>
                {getTranslate('Available Rooms')}
              </Typography>
              {isMobile && (
                <Button
                  variant="text"
                  startIcon={<FilterListIcon />}
                  onClick={() => setFilterOpen(true)}>
                  <Typography className={classes.primaryTitle}>
                    {getTranslate('Filters')}
                  </Typography>
                </Button>
              )}
            </div>
            <Hidden smUp>
              <PaymentWallet
                title={getTranslate('Payment Method')}
                options={walletTypes}
                selectedWalletType={selectedWalletType}
                setSelectedWalletType={setSelectedWalletType}
              />
            </Hidden>
          </>
        ) : (
          <></>
        )}
        <div className={classes.availableRoomContainer}>
          <div className={classes.roomTypesContainer}>
            {searchData && searchData?.rooms?.length > 0 && filteredRoomType ? (
              <>
                {filteredRoomType.map((room, i) => (
                  <RoomTypeDetails
                    key={i}
                    room={room}
                    nonBillateralWallet={nonBillateralWallet}
                    creditors={allCreditors}
                    currency={searchAvailabilityInput.currency}
                    validProviderCode={validProviderCode}
                    setValidProviderCode={setValidProviderCode}
                    searchAvailabilityInput={searchAvailabilityInput}
                    selectedWalletType={selectedWalletType}
                    getCart={getCart}
                    loadingForGetCart={loadingForGetCart}
                    selectedItemHash={selectedItemHash}
                    setSelectedItemHash={setSelectedItemHash}
                    cartData={cartData}
                    uniqueProviders={initialData?.uniqueProviders || []}
                    itemsInCart={itemsInCart}
                    setItemsInCart={setItemsInCart}
                  />
                ))}
                <div className={classes.btnContainer}>
                  <div />
                  <ButtonBase
                    component={LocalizedLink}
                    disableRipple
                    disableTouchRipple
                    disabled={buttonDisabled}
                    className={classes.bookingButton}
                    to={`/book/${params.channelId}/${params.code}/${params.name}/bookstepper/cart`}>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={buttonDisabled}
                      className={classes.btnContinue}>
                      <Typography className={classes.continueText}>
                        {getTranslate('Reserve')}
                      </Typography>
                    </Button>
                  </ButtonBase>
                </div>
              </>
            ) : (
              !loadingForSearchAvailability && (
                <div className={classes.noResultFound}>
                  <img src={noResultsFound} className={classes.img} />
                  <Typography variant="h2" className={classes.noResults}>
                    {getTranslate('No result Found')}
                  </Typography>
                </div>
              )
            )}
          </div>
          <Hidden smDown>
            <div className={classes.filtersContainer}>
              <SearchAvailibilityFilters
                searchData={searchData}
                priceRange={priceRange}
                setPriceRange={setPriceRange}
                searchAvailabilityInput={searchAvailabilityInput}
                setSearchAvailabilityInput={setSearchAvailabilityInput}
                selectedProviders={selectedProviders}
                setSelectedProviders={setSelectedProviders}
                selectedRoomFacilities={selectedRoomFacilities}
                walletTypes={walletTypes}
                selectedRoomTypes={selectedRoomTypes}
                selectedWalletType={selectedWalletType}
                setSelectedRoomFacilities={setSelectedRoomFacilities}
                setSelectedWalletType={setSelectedWalletType}
                setselectedRoomTypes={setselectedRoomTypes}
                isUserPriceChange={isUserPriceChange}
                itemsInCart={itemsInCart}
                setFilteredRoomType={setFilteredRoomType}
                initialData={initialData}
                setInitialData={setInitialData}
                maxPriceRange={maxPriceRange}
              />
            </div>
          </Hidden>
        </div>
      </div>
      <AdotelSkeleton
        open={loadingForSearchAvailability}
        circlesColor={theme.palette.primary.main}
        numberOfCircles={4}
      />
      <Lightbox
        open={openGallary}
        close={() => setOpenGallary(false)}
        slides={slides}
        thumbnails={{
          position: 'bottom',
          width: 100,
          height: 100,
          imageFit: 'cover'
        }}
        plugins={[Thumbnails]}
        carousel={{
          finite: true
        }}
        styles={{
          container: {
            backgroundColor: 'black'
          }
        }}
      />
      <RedirectModal
        isOpen={showRedirectModal}
        title={redirectTitle}
        onClose={() => {
          setShowRedirectModal(false)
        }}
        onClick={() =>
          history.push(
            `/book/${params.channelId}/${params.code}/${params.name}`
          )
        }
      />
      <Hidden smUp>
        <FilterDrawer
          open={filterOpen}
          onClose={() => setFilterOpen(false)}
          onOpen={() => {
            setFilterOpen(true)
          }}
          searchData={searchData}
          priceRange={priceRange}
          setPriceRange={setPriceRange}
          searchAvailabilityInput={searchAvailabilityInput}
          setSearchAvailabilityInput={setSearchAvailabilityInput}
          selectedRoomFacilities={selectedRoomFacilities}
          selectedRoomTypes={selectedRoomTypes}
          setSelectedRoomFacilities={setSelectedRoomFacilities}
          setselectedRoomTypes={setselectedRoomTypes}
          isUserPriceChange={isUserPriceChange}
          setFilteredRoomType={setFilteredRoomType}
          initialData={initialData}
          setInitialData={setInitialData}
          selectedProviders={selectedProviders}
          setSelectedProviders={setSelectedProviders}
          maxPriceRange={maxPriceRange}
        />
      </Hidden>
    </>
  )
}

export default BookingHotelSearchResult
